import { useParams } from "react-router-dom";
import { JobsList } from "../components/JobsList";

export const JobsPage = () => {
    const { companyId } = useParams();
    return <JobsList companyId={companyId ?? null} />;
};
